module.exports = __webpack_public_path__ + "media/images/frontend/covid19_national_link-fc40d2eec7eb71ba63cc41714ef507c5.svg";